import { render, staticRenderFns } from "./UpdateServiceCatalogPriceModal.vue?vue&type=template&id=fe5f8dc0&scoped=true&"
import script from "./UpdateServiceCatalogPriceModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateServiceCatalogPriceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5f8dc0",
  null
  
)

export default component.exports